module.exports = __webpack_public_path__ + "img/logo-red-branco-6x.e9334b9b.png";